// src/redux/crypto/deviceKeySlice.ts

import { createSlice, createAsyncThunk, PayloadAction } from '@reduxjs/toolkit';
import {
  // generateDeviceKeyPair,
  fetchUserDevices,
  // removeDeviceKey,
  sendDeviceDeletionCode, verifyAndDeleteDevice
} from '../../services/crypto/deviceKeyApi';
import { logoutUser } from '../auth/authSlice';
import { isCurrentDevice, clearDeviceId } from "../../utils/common/deviceHelpers";
import { Device, DeviceKeyState } from '../../types/crypto/cryptoTypes';


const initialState: DeviceKeyState = {
  devices: [],
  loading: false,
  error: null,
  generatingKey: false,
  currentDeviceId: typeof window !== "undefined" ? localStorage.getItem("device_id") || null : null,
};


// export const generateDeviceKey = createAsyncThunk(
//   'deviceKeys/generateDeviceKey',
//   async (_, thunkAPI) => {
//     try {
//       return await generateDeviceKeyPair();
//     } catch (error: any) {
//       return thunkAPI.rejectWithValue(error?.message || 'Failed to generate device key');
//     }
//   }
// );

export const getDevices = createAsyncThunk( 
  'deviceKeys/getDevices',
  async (_, thunkAPI) => {
    try {
      return await fetchUserDevices();
    } catch (error: any) {
      return thunkAPI.rejectWithValue(error?.message || 'Failed to fetch devices');
    }
  }
);

// export const deleteDevice = createAsyncThunk(
//   'deviceKeys/deleteDevice',
//   async (deviceId: string, thunkAPI) => {
//     try {
//       await removeDeviceKey(deviceId);
//       return deviceId;
//     } catch (error: any) {
//       return thunkAPI.rejectWithValue(error?.message || 'Failed to remove device');
//     }
//   }
// );

export const sendDeviceDeletionCodeThunk = createAsyncThunk(
  'deviceKeys/sendDeletionCode',
  async (deviceId: string, thunkAPI) => {
    try {
      const result = await sendDeviceDeletionCode(deviceId);
      return { deviceId, message: result.message };
    } catch (error: any) {
      return thunkAPI.rejectWithValue(
        error?.response?.data?.error || "Failed to send verification code"
      );
    }
  }
);



export const verifyAndDeleteDeviceThunk = createAsyncThunk(
  "deviceKeys/verifyDeleteDevice",
  async (
    { deviceId, code }: { deviceId: string; code: string },
    { dispatch, rejectWithValue }
  ) => {
    try {
      const result = await verifyAndDeleteDevice(deviceId, code);

      const normalized = deviceId.trim().toLowerCase();
      if (isCurrentDevice(normalized)) {
        try {
          await dispatch(logoutUser()).unwrap();
        } finally {
          await clearDeviceId(true);
        }
      }

      return { deviceId: normalized, message: result.message };
    } catch (error: any) {
      return rejectWithValue(
        error?.response?.data?.error || "Verification failed"
      );
    }
  }
);





const deviceKeySlice = createSlice({
  name: 'deviceKeys',
  initialState,
  reducers: {
    clearError: (state) => {
      state.error = null;
    },
  },
  extraReducers: (builder) => {
    builder
      // Generate key
      // .addCase(generateDeviceKey.pending, (state) => {
      //   state.generatingKey = true;
      //   state.error = null;
      // })
      // .addCase(generateDeviceKey.fulfilled, (state) => {
      //   state.generatingKey = false;
      // })
      // .addCase(generateDeviceKey.rejected, (state, action) => {
      //   state.generatingKey = false;
      //   state.error = action.payload as string;
      // })

      // Get devices
      .addCase(getDevices.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(getDevices.fulfilled, (state, action: PayloadAction<Device[]>) => {
        state.loading = false;
        state.devices = action.payload;
      })
      .addCase(getDevices.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload as string;
      })

      // // Delete device
      // .addCase(deleteDevice.fulfilled, (state, action: PayloadAction<string>) => {
      //   state.devices = state.devices.filter((d) => d.device_id !== action.payload);
      // })

      // Send Device Deletion Code Thunk ----------------------------------
      .addCase(sendDeviceDeletionCodeThunk.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(sendDeviceDeletionCodeThunk.fulfilled, (state) => {
        state.loading = false;
      })
      .addCase(sendDeviceDeletionCodeThunk.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload as string;
      })

      // Verify And Delete Device Thunk ----------------------------------
      .addCase(verifyAndDeleteDeviceThunk.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(
        verifyAndDeleteDeviceThunk.fulfilled,
        (state, action: PayloadAction<{ deviceId: string; message: string }>) => {
          state.loading = false;
          state.devices = state.devices.filter((d) => d.device_id !== action.payload.deviceId);
        }
      )
      .addCase(verifyAndDeleteDeviceThunk.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload as string;
      });
  },
});

export const { clearError } = deviceKeySlice.actions;
export default deviceKeySlice.reducer;
